import Vue from 'vue'
import Vuex from 'vuex'

import modemsChallenges from './modules/modems-challenges'
import modems from './modules/modems'
import planograms from './modules/planograms'
import stocks from './modules/stocks'
import components from './modules/components'
import kb from './modules/kb'
import vms from './modules/vms'
import sales from './modules/sales'
import vm from './modules/vm'
import vends from './modules/vends'
import company from './modules/company'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,

    modules: {
        modems,
        modemsChallenges,
        planograms,
        vms,
        vm,
        vends,
        stocks,
        components,
        kb,
        company,
        sales
    },

    state: {
        isMobile: false,
        isSidebarCollapsed: false,
        toMobileWidth: 767
    },

    mutations: {
        TOGGLE_SIDEBAR(state) {
            state.isSidebarCollapsed = !state.isSidebarCollapsed
        },

        SET_SIDEBAR(state, collapsed) {
            state.isSidebarCollapsed = collapsed
        },

        isMobile(state, data) {
            state.isMobile = !!data
        }
    },

    actions: {
        toggleSidebar({ commit }) {
            commit('TOGGLE_SIDEBAR')
        }
    }
})
